<!-- src/views/Inventario/InventoryLayout.vue -->
<template>
  <AppNavbar/>
  <div class="d-flex flex-column inventory-layout">
    <AppHeader title="Catálogo e Inventario" class="header-compact px-4 border-bottom">
      <template #buttons>
        <button
          v-if="showBackButton"
          type="button"
          class="btn btn-outline-secondary inventory-back-button"
          @click="goBack"
        >
          <i class="bi bi-arrow-left"></i>
          Volver
        </button>
      </template>
    </AppHeader>

    <div class="inventory-body d-flex flex-grow-1">
      <main class="flex-fill p-4">
        <router-view/>
      </main>
    </div>
  </div>
</template>

<script>
  import AppHeader from '@/components/AppHeader.vue';
  import AppNavbar from '@/components/AppNavbar.vue';
  export default {
    name: 'InventoryLayout',
    components: {
      AppHeader,
      AppNavbar
    },
    computed: {
      showBackButton() {
        return this.$route?.name && this.$route.name !== 'InvDashboard';
      }
    },
    methods: {
      goBack() {
        if (window.history.length > 1) {
          this.$router.back();
          return;
        }
        this.$router.push({ name: 'InvDashboard' });
      }
    }
  }
</script>

<style scoped>

.inventory-layout {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

/* Solo el cuerpo crece. Con `.inventory-layout .d-flex` también crecía el
   header de AppHeader (es d-flex) y el título ocupaba ~220 px (ux-operativa-v2 RF-4). */
.inventory-layout > .inventory-body {
  flex-grow: 1;
}

.header-compact  {
  padding-top: .5rem;
  padding-bottom: .5rem;
}

.inventory-back-button {
  display: inline-flex;
  align-items: center;
  gap: 0.45rem;
}

.inventory-body {
  position: relative;
  min-height: 0;
}

main {
  background: #f9f9f9;
  overflow-y: auto;
  min-width: 0;
}

@media (max-width: 991.98px) {
  .header-compact {
    padding-left: 1rem !important;
    padding-right: 1rem !important;
  }

  main {
    padding: 1rem !important;
  }
}
</style>
